import {useEffect, useState} from 'react'

export function useViewportBelow(maxPx: number): boolean {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined') return false
        return window.innerWidth < maxPx
    })

    useEffect(() => {
        if (typeof window === 'undefined') return
        const mq = window.matchMedia(`(max-width: ${maxPx - 1}px)`)
        const update = () => setMatches(mq.matches)
        update()
        mq.addEventListener('change', update)
        return () => mq.removeEventListener('change', update)
    }, [maxPx])

    return matches
}
